import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as loginActions from '../../actions/authActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row, Col } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import LoginForm from './LoginForm';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: {
        username: '',
        password: '',
      },
      errors: {},
    };
  }

  updateCredentialState = (event) => {
    const field = event.target.id;
    let credentials = Object.assign({}, this.state.credentials);
    credentials[field] = event.target.value;
    this.setState({ credentials: credentials });
  };

  formIsValid() {
    const { credentials } = this.state;
    let errors = {};
    let isValid = true;

    if (credentials.username === '') {
      errors.credentials = 'Invalid username or password';
      isValid = false;
    }
    if (credentials.password === '') {
      errors.credentials = 'Invalid username or password';
      isValid = false;
    }

    this.setState({ errors: errors });
    return isValid;
  }

  logIn = (event) => {
    event.preventDefault();
    if (!this.formIsValid()) return;
    this.props.actions
      .logIn(this.state.credentials)
      .then(() => {
        if (this.props.currentUser.resetRequired)
          this.props.history.push('/change-password');
        else this.props.history.push('/dashboard');
      })
      .catch((error) => {
        let { errors } = this.state;
        errors.credentials = 'Invalid username or password';
        this.setState({ errors: errors });
        //toast.error(error);
      });
  };

  render() {
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <h1 className="text-center my-4">Login</h1>
            </Col>
          </Row>
          <LoginForm
            credentials={this.state.credentials}
            onChange={this.updateCredentialState}
            onLogin={this.logIn}
            loggingIn={false}
            errors={this.state.errors}
          />
        </Container>
      </div>
    );
  }
}

LoginPage.propTypes = {
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginPage)
);



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js